import { Carrier, Port, Route, Vessel, Schedule } from './../';

export class Voyage {
  // for display
  public viewDetails: boolean;

  public voyage: string;
  public carrier: Carrier;
  public route: Route;

  public schedules: Array<Schedule> = [];

  constructor(json: any) {
    this.voyage = json.voyage || '';
    this.carrier = new Carrier(json.carrier);
    this.route = new Route(json.route);

    this.schedules.push(new Schedule(json));
    this.viewDetails = false;
  }

  addSchedule(schedule: Schedule): void {
    this.schedules.push(schedule);
  }
}



// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/shared/models/voyage-models/voyage.ts